module.exports = __webpack_public_path__ + "static/2-4d1aa9ce8867bed883d40910f323419b.png";